import { Typography } from "@mui/material";
import { MprcFilterIconButton } from "components/filter/MprcFilterIconButton";
import { MprcFilterLine } from "components/filter/MprcFilterLine";
import { MprcText } from "components/MprcText";
import * as React from "react";

interface IPropFilter {
    readonly: boolean;
    filtered: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface IProps {
    children?: React.ReactNode;
    title: string;
    subtitle?: string;
    filterAction?: IPropFilter;
    actions?: React.ReactNode[];
}

export const MprcFilterBoxContent: React.FC<IProps> = ({ title, subtitle, filterAction, actions, children }) => {
    return (
        <>
            <MprcFilterLine>
                <Typography variant="h3" >{title}</Typography>
                {
                    subtitle &&
                    <Typography variant="subtitle1" >{subtitle}</Typography>
                }

                <div>
                    {
                        filterAction != undefined && !filterAction.readonly &&
                        <MprcText color="muted">
                            <MprcFilterIconButton
                                filtered={filterAction.filtered}
                                onClick={filterAction.onClick}
                            />
                        </MprcText>
                    }
                    {actions}
                </div>
            </MprcFilterLine>
            {children}
        </>
    );
};
